import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { useState, useEffect } from "react";

const UploadPdfModal = ({
  visible,
  close,
  onUpload,
  loading = false
}) => {
  const [uploadFile, setUploadFile] = useState(null);
  const [fileValid, setFileValid] = useState(false);

  useEffect(() => {
    const valid = uploadFile?.type === "application/pdf";
    setFileValid(valid);
  }, [uploadFile]);

  const handleFileChanged = (e) => {
    if (e.target.files) {
      setUploadFile(e.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (uploadFile && fileValid) {
      onUpload(uploadFile);
    }
  };

  const handleClose = () => {
    setUploadFile(null);
    close();
  };

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="text-capitalize">
          <h1 className="text-axis-offblack icon-text-wrapper">
            <BsFileEarmarkPdf className="icon-right-spacing" />
            Upload Reference PDF
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Select PDF File</Form.Label>
            <div className="file-upload-container p-3 border rounded mb-3 text-center" 
                 onClick={() => document.getElementById('uploadFileInput').click()}
                 style={{cursor: 'pointer', backgroundColor: '#f8f9fa', borderStyle: 'dashed'}}>
              <BsFileEarmarkPdf size={30} className="mb-2 text-primary" />
              <p className="mb-1">Click to browse</p>
              <p className="small text-muted mb-0">PDF files only</p>
              <Form.Control
                id="uploadFileInput"
                type="file"
                onChange={handleFileChanged}
                isValid={fileValid && uploadFile}
                isInvalid={uploadFile && !fileValid}
                className="d-none"
                accept=".pdf"
              />
            </div>
            
            {uploadFile && (
              <div className="file-details p-3 border rounded bg-light">
                <div className="d-flex align-items-center">
                  <BsFileEarmarkPdf className="me-2 text-primary" />
                  <div className="flex-grow-1">
                    <div className="fw-semibold text-truncate">{uploadFile.name}</div>
                    <div className="small text-muted">
                      {uploadFile.type} • {(uploadFile.size / 1024).toFixed(1)} KB
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Form.Control.Feedback type="invalid">
              Please select a valid PDF file
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleUpload}
          disabled={loading || !fileValid || !uploadFile}
        >
          {loading ? "Uploading..." : "Upload PDF"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadPdfModal;